module.exports = __webpack_public_path__ + "img/hero_shelves.42e74579.jpg";